/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import {
	transparentize
} from "polished";
import styled from "styled-components";

import {
	columnWrapper,
	ellipsis,
	rowWrapper
} from "../../styled/styled-extends";
import { 
	setFont,
	setPosition
} from "../../styled/styled-mixins";
import {
	typo
} from "../../styled/styled-variables";

// EXPORT

export const ReservationOverlayWrapper = styled.div`
	align-items: center;
	height: 100%;
	justify-content: center;
	padding: 24px;
	width: 100%;
	${setPosition(
		"absolute", 
		{
			"left": 0,
			"top": 0,
			"z-index": 1
		}
	)}
	${columnWrapper}
`;

export const StoreOverlayWrapper = styled.div`
	align-items: center;
	height: 48px;
	justify-content: center;
	width: 100%;
	${setPosition(
		"absolute", 
		{
			"left": 0,
			"top": "-24px",
			"z-index": 2
		}
	)}
	${columnWrapper}

	.img {
		border-radius: 50%;
		height: 48px;	    
		width: 48px;
	}
`;

export const ComponentWrapper = styled.div`
	flex-wrap: wrap;
	gap: 16px;
	justify-content: center;
	padding: 16px;
	width: 100%;
	${rowWrapper}

	> div {
		width: 100%;
	}

	.reservationCardBody {
		padding-top: 32px !important;
		${setPosition("relative")}

		p {
			${columnWrapper}
			width: 100%;

			small {
				${ellipsis}
			}
		}
	}

	.reservationCardHeader {
		padding: 0 !important;
		${setPosition("relative")}

		.img {
			height: 320px;
		}
	}

	@media only screen and (min-width: 390px) {
	}

	@media only screen and (min-width: 576px) {
		gap: 16px;
		padding: 24px;
	}

	@media only screen and (min-width: 768px) {
		> div {
			width: calc(50% - (20px / 2));
		}
	}

	@media only screen and (min-width: 1024px) {
		gap: 24px;
		padding: 32px;

		> div {
			width: calc(33.33% - (48px / 3));
		}
	}

	@media only screen and (min-width: 1280px) {
		gap: 32px;
		padding: 40px;

		> div {
			width: calc(33.33% - (96px / 3));
		}
	}

	@media only screen and (min-width: 1440px) {
		gap: 40px;
		padding: 48px;

		> div {
			width: calc(25% - (120px / 3));
		}
	}

	${(props) => {
		const {
			backgroundColors,
			body,
			card,
			header,
			typoColors
		} = props.theme;

		let loaderWrapperOpacity = 0;
		let loaderWrapperPointerEvents = "none";

		if(props.loaderActive) {
			loaderWrapperOpacity = 1;
			loaderWrapperPointerEvents = "auto";
		}

		return `
			background-color: ${body.background};

			${ReservationOverlayWrapper} {
				background-color: ${transparentize(0.4, backgroundColors.level1)};
				color: ${typoColors.level8};

				span {
					font-weight: 600;
				}

				strong {
					color: ${typoColors.level9};
					font-size: ${typo.fontSizes.large};
				}

				> strong {
					letter-spacing: 3px;
					${setFont(
						typo.fontFamilies.heebo,
						typo.fontSizes.huge,
						500,
						typo.lineHeight.default,
						typoColors.level9
					)}
				}
			}
		`;
	}};
`;
